import AudioPlayer from "react-h5-audio-player";

import NotificationCard from "./NotificationCard";

export default function AudioNotificationCard(props) {
    return (
        <NotificationCard
            {...props}
            type="audio"
            destination={"/audio/" + props.notification.file}
            mediaContent={
                <AudioPlayer
                    autoPlay={false}
                    src={props.notification.url}
                />
            }
            showComments
        />
    );
}
